import img_2992694054_main from "../assets/images/2992694054/8181169711_m.webp"
import img_2883603702_main from "../assets/images/2883603702/8145378747_m.webp"

export const productsImages = {
   img_2992694054: [img_2992694054_main],
   img_2883603702: [img_2883603702_main],
}

